import { gql } from '@apollo/client'

export const GET_PLAYLISTS = gql`
  query GetPlaylists {
    playlistList(
        userCurrent: true,
        order: [["createdAt", "ASC"]]
    ) {
        playlists {
            id
            uid
            playlistType
            playlistName
        }
    }
}
`

export const CREATE_PLAYLIST = gql`
  mutation CreatePlaylist ($playlistName: String!) {
    playlistCreate(playlist: { playlistType: "user", playlistName: $playlistName }) {
        playlist {
            id
            uid
            playlistType
            playlistName
        }
    }
}
`

export const DELETE_PLAYLIST = gql`
    mutation DeletePlaylist ($playlistType: String!) {
        playlistDelete(playlist: { playlistType: $playlistType }) {
            playlist {
                uid
                playlistType
                id
                playlistName
            }
        }
    }
`

export const ADD_TO_PLAYLIST = gql`
  mutation addToPlaylist ($contentId: Int!, $contentType: String!, $playlistType: String!, $playlistId: ID ) {
    playlistCreatePlaylistItem(
        playlistItem: { contentId: $contentId, contentType: $contentType }
        playlist: { id: $playlistId, playlistType: $playlistType }
        createPlaylistIfNotExist: true
    ) {
        playlistItem {
            id
            playlistId
            contentType
            contentId
            titleGroupId
            playlistPosition
            playlist {
                playlistType
                playlistName
                id
            }
            content {
                id
                title
                contentId
            }
        }
    }
}
`

export const REMOVE_FROM_PLAYLIST = gql`
  mutation removeFromPlaylist ($contentId: Int!, $contentType: String!, $playlistId: ID!, $playlistType: String!) {
    playlistDeletePlaylistItem(
        playlistItem: {
            contentId: $contentId
            contentType: $contentType
        }
        playlist: { id: $playlistId, playlistType: $playlistType }
    ) {
        playlistItem {
            id
            playlistId
            contentType
            contentId
            titleGroupId
            playlistPosition
            playlist {
                playlistType
                playlistName
                id
            }
        }
    }
}
`

export const GET_PLAYLIST_ITEMS = gql`
  query GetPlaylistItems ($playlistId: ID!, $playlistType: String!, $language: [String]!, $imageType: [String]!, $limit: Int!, $offset: Int!, $order: [[String]]) {
    playlistItemList(
        userCurrent: true
        playlists: [{ id: $playlistId, playlistType: $playlistType }]
        limit: $limit
        offset: $offset
        order: $order
    ) {
        playlistItems {
            id
            contentId
            contentType
            playlistId
            playlistPosition
            content(language: $language) {
                contentAnalytic {
                    votesUpCountTotal
                    votesCountTotal
                }
                id
                title
                path
                episodeNumber
                seasonNumber
                displayType
                studio
                contentType
                subType
                contentId
                titleGroupId
                seasonsCount
                episodesCount
                isNew
                primaryLanguage
                languageFullText
                cast
                instructor
                published
                shortDescription
                references (typesByTypeTag: true) {
                    id
                    contentReferenceType {
                        type
                    }
                    contentTo (language: $language) {
                        title
                        contentType
                        contentId
                        language
                        path
                    }
                }
                featureMedia {
                    duration
                    mediaId
                    mediaAssets {
                        language
                        mediaReferenceType
                    }
                    contentPolicy {
                        shareAllowed
                        accessCheck {
                            allowed
                            countryAllowed
                            subscriptionsAllowed
                            isFreeAllowed
                        }
                        optionIds
                    }
                    userMediaPosition {
                        position
                    }
                }
                previewMedia {
                    mediaId
                }
                imageContentRelationships (
                    language: $language
                    types: $imageType
                ) {
                    type
                    image {
                        url
                    }
                }
                contentSeries(language: $language) {
                    id
                    contentId
                    title
                    path
                }
                contentFeatured (language: $language) {
                    content {
                        contentAnalytic {
                            votesUpCountTotal
                            votesCountTotal
                        }
                        id
                        title
                        path
                        ctaProductUrl
                        episodeNumber
                        seasonNumber
                        displayType
                        contentType
                        subType
                        contentId
                        isNew
                        primaryLanguage
                        languageFullText
                        shortDescription
                        cast
                        instructor
                        references (typesByTypeTag: true) {
                            id
                            contentReferenceType {
                                type
                            }
                            contentTo (language: $language) {
                                title
                                contentType
                                contentId
                                language
                                path
                            }
                        }
                        featureMedia {
                            duration
                            mediaId
                            mediaAssets {
                                language
                                mediaReferenceType
                            }
                            contentPolicy {
                                shareAllowed
                                accessCheck {
                                    allowed
                                    countryAllowed
                                    subscriptionsAllowed
                                    isFreeAllowed
                                }
                                optionIds
                            }
                            userMediaPosition {
                                position
                            }
                        }
                        previewMedia {
                            mediaId
                        }
                    }
                    featuredType
                }
            }
        }
        offset
        limit
        count
    }
}
`

export const GET_PURCHASES_LIST = gql`
  query GetPurchasesList ($language: [String]!, $imageType: [String]!, $imageLanguage: [String]!, $assetLanguage: String!, $limit: Int, $offset: Int, $order: [[String]]) {
    ecommerceSkuMappingsList(
        userCurrent: true
        limit: $limit
        offset: $offset
        order: $order
    ) {
        ecommerceSkuMappings {
            ecommerceSku
            provider
            contentTitleGroupIds
            entitlementDurationSeconds
            title
            contentRelated (language: $language, content: [{ contentType: "series" }, { contentType: "video" }]) {
                contentAnalytic {
                    votesUpCountTotal
                    votesCountTotal
                }
                id
                title
                path
                episodeNumber
                seasonNumber
                displayType
                studio
                contentType
                subType
                contentId
                titleGroupId
                seasonsCount
                episodesCount
                isNew
                primaryLanguage
                languageFullText
                cast
                instructor
                published
                shortDescription
                references (typesByTypeTag: true) {
                    id
                    contentReferenceType {
                        type
                    }
                    contentTo (language: $language) {
                        title
                        contentType
                        contentId
                        language
                        path
                    }
                }
                featureMedia {
                    duration
                    mediaId
                    mediaAssets {
                        language
                        mediaReferenceType
                    }
                    contentPolicy {
                        shareAllowed
                        accessCheck {
                            allowed
                            countryAllowed
                            subscriptionsAllowed
                            isFreeAllowed
                        }
                        optionIds
                    }
                    userMediaPosition {
                        position
                    }
                }
                previewMedia {
                    mediaId
                }
                imageContentRelationships (
                    language: $imageLanguage
                    types: $imageType
                ) {
                    type
                    image {
                        url
                    }
                }
                contentSeries(language: $language) {
                    id
                    contentId
                    title
                    path
                }
                contentFeatured (language: $language) {
                    content {
                        contentAnalytic {
                            votesUpCountTotal
                            votesCountTotal
                        }
                        id
                        title
                        path
                        ctaProductUrl
                        episodeNumber
                        seasonNumber
                        displayType
                        contentType
                        subType
                        contentId
                        isNew
                        primaryLanguage
                        languageFullText
                        shortDescription
                        cast
                        instructor
                        references (typesByTypeTag: true) {
                            id
                            contentReferenceType {
                                type
                            }
                            contentTo (language: $language) {
                                title
                                contentType
                                contentId
                                language
                                path
                            }
                        }
                        featureMedia {
                            duration
                            mediaId
                            mediaAssets {
                                language
                                mediaReferenceType
                            }
                            contentPolicy {
                                shareAllowed
                                accessCheck {
                                    allowed
                                    countryAllowed
                                    subscriptionsAllowed
                                    isFreeAllowed
                                }
                                optionIds
                            }
                            userMediaPosition {
                                position
                            }
                        }
                        previewMedia {
                            mediaId
                        }
                    }
                    featuredType
                }
            }
            contentProviders {
                contentId
                provider
                content {
                    id
                    contentId
                    contentType
                    language
                    titleGroupId
                    contentAssetReferences (contentAssetReferences: {type: "worksheet"}) {
                        asset(filter: { language: $assetLanguage }) {
                            originalFileName
                            language
                            renderUrl
                            mimeType
                            uuid
                            id
                        }
                        contentAssetReferenceType {
                            type
                        }
                    }
                }
            }
        }
        offset
        limit
        count
    }
}
`
